exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.identity-validation-component[data-v-1a27471c] {\r\n    padding: 0 0 1em 0;\n}\n.manual-status-panel[data-v-1a27471c] {\r\n    margin-bottom: 1.5em;\n}\n.review-note[data-v-1a27471c] {\r\n    font-style: italic;\r\n    color: #666;\n}\n.sms-validation-item[data-v-1a27471c] {\r\n    border-left: 4px solid #5cb85c;\n}\n.sms-validation-item h4[data-v-1a27471c] {\r\n    color: #5cb85c;\n}\n.sms-validation-item h4 i[data-v-1a27471c] {\r\n    margin-right: 0.5em;\n}\r\n", ""]);

// exports
